import Footer from "../../../components/footer/Footer";
import Imagewheel from "../../../components/imagewheel/Imagewheel";
import Newsletter from "../../../components/newsletter/Newsletter";
import Vacancies from "../../../components/vacancies/Vacancies";
import { VacancyPageContainer } from "./VacancyStyles";

function Vacancy() {
  const images = ["/assets/15.jpg", "/assets/16.jpg", "/assets/17.jpg"];

  return (
    <VacancyPageContainer>
      {/* Healthcare - Vacancy: Imagewheel */}
      <Imagewheel images={images} isVacancy={true} />

      {/* Healthcare - Vacancy: Vacancies */}
      <Vacancies />

      {/* Healthcare - Vacancy: Newsletter */}
      <Newsletter />

      {/* Healthcare - Vacancy: Footer */}
      <Footer />
    </VacancyPageContainer>
  );
}

export default Vacancy;
